import { updateSession } from "../DAL/dal";
import { allStatistic } from './info'
const ExcelJS = require("exceljs");


const compiledColumnsFunction = (data) => { // функция которая компилирует колонки в таблице excel

    let arrayKeys = [];
    data.map((el) => {
        for (let key in el) {
            if (key == "surveyplan") {
                for (let index = 0; index < data.length; index++) {
                    for (let i = 0; i < data[index].surveyplan?.chooses.length; i++) {
                        arrayKeys.push({
                            header: 'Выбор плана обследования/Время',
                            key: 'stepTime1',
                            width: 20,
                        });
                        for (
                            let j = 0;
                            j < data[index].surveyplan?.chooses[i].variants.length;
                            j++
                        ) {
                            arrayKeys.push({
                                header: data[index].surveyplan?.chooses[i].variants[j],
                                key: data[index].surveyplan?.chooses[i].variants[j],
                                width: 20,
                            });
                        }
                    }
                }
                // arrayKeys.push({
                //     header: 'Комментарий к плану обследования',
                //     key: "commentarySurvey",
                //     width: 20,
                // });
                arrayKeys.push({
                    header: 'Результат',
                    key: "resultSurvey",
                    width: 20,
                });
            } else if (key == "principaldiagnosis") {
                for (let index = 0; index < data.length; index++) {
                    for (
                        let i = 0;
                        i < data[index].principaldiagnosis?.chooses.length;
                        i++
                    ) {
                        arrayKeys.push({
                            header: 'Постановка диагноза/Время',
                            key: 'stepTime2',
                            width: 20,
                        });
                        for (
                            let j = 0;
                            j < data[index].principaldiagnosis?.chooses[i].variants.length;
                            j++
                        ) {
                            arrayKeys.push({
                                header: data[index].principaldiagnosis?.chooses[i].variants[j],
                                key: data[index].principaldiagnosis?.chooses[i].variants[j],
                                width: 20,
                            });
                        }
                    }
                }
                // arrayKeys.push({
                //     header: 'Комментарий к диагнозу',
                //     key: "commentaryDiagnosis",
                //     width: 20,
                // });
                arrayKeys.push({
                    header: 'Результат',
                    key: "resultDiagnosis",
                    width: 20,
                });
            } else if (key == "progressionfactors") {
                for (let index = 0; index < data.length; index++) {
                    for (
                        let i = 0;
                        i < data[index].progressionfactors?.chooses.length;
                        i++
                    ) {
                        arrayKeys.push({
                            header: 'Определение факторов прогрессии/Время',
                            key: 'stepTime3',
                            width: 20,
                        });
                        for (
                            let j = 0;
                            j < data[index].progressionfactors?.chooses[i].variants.length;
                            j++
                        ) {
                            arrayKeys.push({
                                header: data[index].progressionfactors?.chooses[i].variants[j],
                                key: data[index].progressionfactors?.chooses[i].variants[j],
                                width: 20,
                            });
                        }
                    }
                }
                // arrayKeys.push({
                //     header: 'Комментарий к факторам прогрессии',
                //     key: "commentaryProgression",
                //     width: 20,
                // });
                arrayKeys.push({
                    header: 'Результат',
                    key: "resultProgression",
                    width: 20,
                });
            } else if (key == "treatment") {
                for (let index = 0; index < data.length; index++) {
                    for (let i = 0; i < data[index].treatment?.chooses.length; i++) {
                        arrayKeys.push({
                            header: 'Назначение лечения/Время',
                            key: 'stepTime4',
                            width: 20,
                        });
                        for (
                            let j = 0;
                            j < data[index].treatment?.chooses[i].variants.length;
                            j++
                        ) {
                            arrayKeys.push({
                                header: data[index].treatment?.chooses[i].variants[j],
                                key: data[index].treatment?.chooses[i].variants[j],
                                width: 20,
                            });
                        }
                    }
                }
                // arrayKeys.push({
                //     header: 'Комментарий к лечению',
                //     key: "commentaryTreatment",
                //     width: 20,
                // });
                arrayKeys.push({
                    header: 'Результат',
                    key: "resultTreatment",
                    width: 20,
                });
            } else if (key == "alpha_adrenoblocker") {
                for (let index = 0; index < data.length; index++) {
                    for (let i = 0; i < data[index].alpha_adrenoblocker?.chooses.length; i++) {
                        arrayKeys.push({
                            header: 'Альфа-адреноблокатор/Время',
                            key: 'stepTime5',
                            width: 20,
                        });
                        for (
                            let j = 0;
                            j < data[index].alpha_adrenoblocker?.chooses[i].variants.length;
                            j++
                        ) {
                            arrayKeys.push({
                                header: data[index].alpha_adrenoblocker?.chooses[i].variants[j],
                                key: data[index].alpha_adrenoblocker?.chooses[i].variants[j],
                                width: 20,
                            });
                        }
                    }
                }
                // arrayKeys.push({
                //     header: 'Комментарий к альфа-адреноблокатор',
                //     key: "commentaryAlpha",
                //     width: 20,
                // });
                arrayKeys.push({
                    header: 'Результат',
                    key: "resultAlpha",
                    width: 20,
                });
            }

            else if (key == "futuretreatment") {
                for (let index = 0; index < data.length; index++) {
                    for (let i = 0; i < data[index].futuretreatment?.chooses.length; i++) {
                        arrayKeys.push({
                            header: 'Шаг по дальнейшей тактике лечения/Время',
                            key: 'stepTime6',
                            width: 20,
                        });
                        for (
                            let j = 0;
                            j < data[index].futuretreatment?.chooses[i].variants.length;
                            j++
                        ) {
                            arrayKeys.push({
                                header: data[index].futuretreatment?.chooses[i].variants[j],
                                key: data[index].futuretreatment?.chooses[i].variants[j],
                                width: 20,
                            });
                        }
                    }
                }
                // arrayKeys.push({
                //     header: 'Комментарий к дальнейшей тактике',
                //     key: "commentaryFutureTreatment",
                //     width: 20,
                // });
                arrayKeys.push({
                    header: 'Результат',
                    key: "resultFutureTreatment",
                    width: 20,
                });
            } else if (key == 'id' || key == 'application_number') {
                continue
            } else {
                arrayKeys.push({
                    header: key == 'ip' ? 'IP' : key == 'sessionid' ? 'Попытки' : key == 'startedtime' ? 'Время начала' : key == 'endedtime' ? 'Время окончания' : undefined,
                    key: key,
                    width: 40,
                });
            }
        }
    })
    const filterForDuble = arrayKeys.reduce((o, i) => {
        if (!o.find((v) => v.key == i.key)) {
            o.push(i);
        }
        return o;
    }, [])
    return filterForDuble;
}


export const exportExcel = (data, utils) => {
    if (!data.length) return alert('отчет пустой')
    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet("Перс. выборка");
    const second_sheet = workbook.addWorksheet("Общая статистика");
    second_sheet.columns = utils.compiledColumnsForSecondSheet
    sheet.properties.defaultRowHeight = 30;
    const array = compiledColumnsFunction(data); // внешняя функция которая компелирует все колонки 
    // console.log(data)
    sheet.columns = array;
    sheet.addRow({})
    second_sheet.addRow({
        all_survey_plan: "Кол-во дошедших",
        all_survey_plan_trys: "Среднее кол-во попыток",
        all_survey_plan_procent: "Процент",
        all_diagnosis: "Кол-во дошедших",
        all_diagnosis_trys: "Среднее кол-во попыток",
        all_diagnosis_procent: "Процент",
        all_factors: "Кол-во дошедших",
        all_factors_trys: "Среднее кол-во попыток",
        all_factors_procent: "Процент",
        all_treatment: "Кол-во дошедших",
        all_treatment_trys: "Среднее кол-во попыток",
        all_treatment_procent: "Процент",
        all_alpha_adrenoblocker: "Кол-во дошедших",
        all_alpha_adrenoblocker_trys: "Среднее кол-во попыток",
        all_alpha_adrenoblocker_procent: "Процент",
        all_future_treatment: "Кол-во дошедших",
        all_future_treatment_trys: "Среднее кол-во попыток",
        all_future_treatment_procent: "Процент",
    })
    second_sheet.mergeCells('B1:D1')
    second_sheet.mergeCells('E1:G1')
    second_sheet.mergeCells('H1:J1')
    second_sheet.mergeCells('K1:M1')
    second_sheet.mergeCells('N1:P1')
    second_sheet.mergeCells('Q1:S1')
    const firstRow = sheet.getRow(1)
    const headerRow = sheet.getRow(2)
    second_sheet.addRow({
        all_counts: allStatistic(data).all_counts,
        all_survey_plan: allStatistic(data)?.all_survey_plan.count,
        all_survey_plan_trys: Number(allStatistic(data)?.all_survey_plan.result()),
        all_survey_plan_procent: (Number(allStatistic(data)?.all_survey_plan.count) / (Number(allStatistic(data).all_counts) / 100)).toFixed(1) + '%',
        all_diagnosis: allStatistic(data)?.all_diagnosis.count,
        all_diagnosis_trys: Number(allStatistic(data)?.all_diagnosis.result()),
        all_diagnosis_procent: (Number(allStatistic(data)?.all_diagnosis.count) / (Number(allStatistic(data).all_counts) / 100)).toFixed(1) + '%',
        all_factors: allStatistic(data)?.all_factors.count,
        all_factors_trys: Number(allStatistic(data)?.all_factors.result()),
        all_factors_procent: (Number(allStatistic(data)?.all_factors.count) / (Number(allStatistic(data).all_counts) / 100)).toFixed(1) + '%',
        all_treatment: allStatistic(data)?.all_treatment.count,
        all_treatment_trys: Number(allStatistic(data)?.all_treatment.result()),
        all_treatment_procent: (Number(allStatistic(data)?.all_treatment.count) / (Number(allStatistic(data).all_counts) / 100)).toFixed(1) + '%',
        all_alpha_adrenoblocker: allStatistic(data)?.all_alpha_adrenoblocker.count,
        all_alpha_adrenoblocker_trys: Number(allStatistic(data)?.all_alpha_adrenoblocker.result()),
        all_alpha_adrenoblocker_procent: (Number(allStatistic(data)?.all_alpha_adrenoblocker.count) / (Number(allStatistic(data).all_counts) / 100)).toFixed(1) + '%',
        all_future_treatment: allStatistic(data)?.all_future_treatment.count,
        all_future_treatment_trys: Number(allStatistic(data)?.all_future_treatment.result()),
        all_future_treatment_procent: (Number(allStatistic(data)?.all_future_treatment.count) / (Number(allStatistic(data).all_counts) / 100)).toFixed(1) + '%',
        all_end: allStatistic(data)?.all_end
    })
    second_sheet.getRow(2).border = { bottom: { style: 'double', color: { argb: 'black' } }, }
    second_sheet.getRow(1).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
    second_sheet.getRow(2).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
    second_sheet.getRow(2).height = 50
    second_sheet.getRow(3).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }

    // console.log(allStatistic(data).all_survey_plan.result())
    // console.log(firstRow._cells)
    firstRow.height = 60
    for (let i in firstRow._cells) {
        sheet.getCell(firstRow._cells[i]._address).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
        sheet.getCell(firstRow._cells[i]._address).font = { name: 'Arial', size: 16 }
    }
    const arr = [[], [], [], [], [], []]
    for (let i in headerRow._worksheet._columns) {
        if (headerRow._worksheet._columns[i]._key == 'stepTime1' || headerRow._worksheet._columns[i]._key == 'resultSurvey') {
            arr[0].push(headerRow._worksheet._columns[i].letter + '2')
        }
        if (headerRow._worksheet._columns[i]._key == 'stepTime2' || headerRow._worksheet._columns[i]._key == 'resultDiagnosis') {
            arr[1].push(headerRow._worksheet._columns[i].letter + '2')
        }
        if (headerRow._worksheet._columns[i]._key == 'stepTime3' || headerRow._worksheet._columns[i]._key == 'resultProgression') {
            arr[2].push(headerRow._worksheet._columns[i].letter + '2')
        }
        if (headerRow._worksheet._columns[i]._key == 'stepTime4' || headerRow._worksheet._columns[i]._key == 'resultTreatment') {
            arr[3].push(headerRow._worksheet._columns[i].letter + '2')
        }
        if (headerRow._worksheet._columns[i]._key == 'stepTime5' || headerRow._worksheet._columns[i]._key == 'resultAlpha') {
            arr[4].push(headerRow._worksheet._columns[i].letter + '2')
        }
        if (headerRow._worksheet._columns[i]._key == 'stepTime6' || headerRow._worksheet._columns[i]._key == 'resultFutureTreatment') {
            arr[5].push(headerRow._worksheet._columns[i].letter + '2')
        }
    }
    for (let i in arr) {
        if (arr[i].length < 2) continue
        sheet.mergeCells(`${arr[i][0]}:${arr[i][1]}`);
        sheet.getCell(arr[i][1]).alignment = { vertical: 'middle', horizontal: 'center' }
        sheet.getCell(arr[i][1]).font = { name: 'Arial', size: 20, bold: true }
        switch (i) {
            case '0':
                sheet.getCell(arr[i][1] ? arr[i][1] : 'O2').value = 'План обследования';
                break;
            case '1':
                sheet.getCell(arr[i][1] ? arr[i][1] : 'S2').value = 'Диагноз';
                break;
            case '2':
                sheet.getCell(arr[i][1] ? arr[i][1] : 'W2').value = 'Факторы прогрессии';
                break;
            case '3':
                sheet.getCell(arr[i][1] ? arr[i][1] : 'AC2').value = 'Лечение';
                break;
            case '4':
                sheet.getCell(arr[i][1] ? arr[i][1] : 'AF2').value = 'альфа-адреноблокаторы';
                break;
            case '5':
                sheet.getCell(arr[i][1] ? arr[i][1] : 'AI2').value = 'Дальнейшая тактика лечения';
                break;
            default:
                break;
        }
    }

    for (let element in data) {
        let objSurveyZero = {}; // добавляем первый объект ключей плана обследований для дальнейшей деструктуризации в первую строку таблицы
        let objDiagnosisZero = {}; // добавляем первый объект ключей диагноза для дальнейшей деструктуризации в первую строку таблицы
        let objFactorsZero = {}; // добавляем первый объект ключей факторов прогрессии для дальнейшей деструктуризации в первую строку таблицы
        let objTreatmentZero = {}; // добавляем первый объект ключей лечения для дальнейшей деструктуризации в первую строку таблицы
        let objAlphaZero = {}; // добавляем первый объект ключей лечения для дальнейшей деструктуризации в первую строку таблицы
        let objFutureTreatmentZero = {}; // добавляем первый объект ключей лечения для дальнейшей деструктуризации в первую строку таблицы
        // 3 мя циклами добавляем варианты первой попытки ввода в главную строку
        for (let i = 0; i < data[element].surveyplan?.chooses[0].variants.length; i++) {
            objSurveyZero[data[element].surveyplan?.chooses[0].variants[i]] = "✓";
            if (data[element].surveyplan?.chooses[0].variants.length != utils.currentCount.resultSurvey || !utils.arrayCorrectVariants.includes(data[element].surveyplan?.chooses[0].variants[i])) {
                // данные однотипные функции отвечают за закрашивание ячеек, правильно, не правильно
                objSurveyZero["resultSurvey"] = false
            }
            else {
                if (objSurveyZero["resultSurvey"] == false) continue
                else objSurveyZero["resultSurvey"] = true
            }
        }
        // это так пока закоментил, так как изначально по ТЗ был только один правильный ответ, потом вдруг нарисовался второй))
        // for ( 
        //     let i = 0;
        //     i < data[element].principaldiagnosis?.chooses[0].variants.length;
        //     i++
        // ) {
        //     objDiagnosisZero[data[element].principaldiagnosis?.chooses[0].variants[i]] =
        //         "✓";
        //     objDiagnosisZero["resultDiagnosis"] = !utils.arrayCorrectVariants.includes(data[element].principaldiagnosis?.chooses[0].variants[i]) ? false : true
        // }
        for (let i = 0; i < data[element].principaldiagnosis?.chooses[0].variants.length; i++) {
            objFactorsZero[data[element].principaldiagnosis?.chooses[0].variants[i]] = "✓";
            if (data[element].principaldiagnosis?.chooses[0].variants.length != utils.currentCount.resultDiagnosis || !utils.arrayCorrectVariants.includes(data[element].principaldiagnosis?.chooses[0].variants[i])) {

                objDiagnosisZero["resultDiagnosis"] = false
            }
            else {
                if (objDiagnosisZero["resultDiagnosis"] == false) continue
                else objDiagnosisZero["resultDiagnosis"] = true
            }
        }
        for (let i = 0; i < data[element].progressionfactors?.chooses[0].variants.length; i++) {
            objFactorsZero[data[element].progressionfactors?.chooses[0].variants[i]] = "✓";
            if (data[element].progressionfactors?.chooses[0].variants.length != utils.currentCount.resultProgression || !utils.arrayCorrectVariants.includes(data[element].progressionfactors?.chooses[0].variants[i])) {

                objFactorsZero["resultProgression"] = false
            }
            else {
                if (objFactorsZero["resultProgression"] == false) continue
                else objFactorsZero["resultProgression"] = true
            }
        }
        for (let i = 0; i < data[element].treatment?.chooses[0].variants.length; i++) {
            objTreatmentZero[data[element].treatment?.chooses[0].variants[i]] = "✓";
            if (data[element].treatment?.chooses[0].variants.length != utils.currentCount.resultTreatment || !utils.arrayCorrectVariants.includes(data[element].treatment?.chooses[0].variants[i])) {
                objTreatmentZero["resultTreatment"] = false
            }
            else {
                if (objTreatmentZero["resultTreatment"] == false) continue
                else objTreatmentZero["resultTreatment"] = true
            }
        }
        for (let i = 0; i < data[element].alpha_adrenoblocker?.chooses[0].variants.length; i++) {
            objAlphaZero[data[element].alpha_adrenoblocker?.chooses[0].variants[i]] = "✓";
            objAlphaZero["resultAlpha"] = !utils.arrayCorrectVariants.includes(data[element].alpha_adrenoblocker?.chooses[0].variants[i]) ? false : true
        }
        for (let i = 0; i < data[element].futuretreatment?.chooses[0].variants.length; i++) {
            objFutureTreatmentZero[data[element].futuretreatment?.chooses[0].variants[i]] = "✓";
            objFutureTreatmentZero["resultFutureTreatment"] = !utils.arrayCorrectVariants.includes(data[element].futuretreatment?.chooses[0].variants[i]) ? false : true
        }
        sheet.addRow({
            sessionid: 'попытка 1',
            ip: data[element].ip,
            startedtime: new Date(data[element].startedtime).toLocaleDateString(),
            stepTime1: data[element].surveyplan?.chooses[0].stepTime1,
            stepTime2: data[element].principaldiagnosis?.chooses[0].stepTime2,
            stepTime3: data[element].progressionfactors?.chooses[0].stepTime3,
            stepTime4: data[element].treatment?.chooses[0].stepTime4,
            stepTime5: data[element].alpha_adrenoblocker?.chooses[0].stepTime5,
            stepTime6: data[element].futuretreatment?.chooses[0].stepTime6,
            // commentarySurvey: data[element].surveyplan?.commentarySurvey,
            // commentaryDiagnosis: data[element].principaldiagnosis?.commentaryDiagnosis,
            // commentaryProgression: data[element].progressionfactors?.commentaryProgression,
            // commentaryTreatment: data[element].treatment?.commentaryTreatment,
            // commentaryAlpha: data[element].alpha_adrenoblocker?.commentaryAlpha,
            // commentaryFutureTreatment: data[element].futuretreatment?.commentaryFutureTreatment,
            ...objSurveyZero, // деструктуризируем и раскидываем значения по ключам для первой строки
            ...objDiagnosisZero, // деструктуризируем и раскидываем значения по ключам для первой строки
            ...objFactorsZero,
            ...objTreatmentZero, // деструктуризируем и раскидываем значения по ключам для первой строки
            ...objAlphaZero, // деструктуризируем и раскидываем значения по ключам для первой строки
            ...objFutureTreatmentZero, // деструктуризируем и раскидываем значения по ключам для первой строки
            endedtime: data[element].endedtime ? new Date(data[element].endedtime).toLocaleTimeString() : null,
        });

        // Далее необходимо создать 3 цикла, которые обработают блоки: план обследования, диагноз и лечение
        for (let i = 1; i < 3; i++) {
            const objSurvey = {}; // в цикле добавляем 2 ую и 3 юю попытки, если они есть
            const objDiagnosis = {}; // в цикле добавляем 2 ую и 3 юю попытки, если они есть
            const objFactors = {}; // в цикле добавляем 2 ую и 3 юю попытки, если они есть
            const objTreatment = {}; // в цикле добавляем 2 ую и 3 юю попытки, если они есть
            const objAlpha = {}; // в цикле добавляем 2 ую и 3 юю попытки, если они есть
            const objFutureTreatment = {}; // в цикле добавляем 2 ую и 3 юю попытки, если они есть
            // цифра 100 условная, врядли когда нибудь будет больше 100 значений, далее мы просто условием проверяем есть ли элемент по индексу
            if (i < data[element].surveyplan?.chooses.length) {
                for (let j in data[element].surveyplan?.chooses[i].variants) {
                    objSurvey[data[element].surveyplan?.chooses[i].variants[j]] = "✓";
                    if (data[element].surveyplan?.chooses[i].variants.length != utils.currentCount.resultSurvey || !utils.arrayCorrectVariants.includes(data[element].surveyplan?.chooses[i].variants[j])) {
                        objSurvey["resultSurvey"] = false
                    }
                    else {
                        if (objSurvey["resultSurvey"] == false) continue
                        else objSurvey["resultSurvey"] = true
                    }
                }
            }
            if (i < data[element].principaldiagnosis?.chooses.length) {
                for (let j in data[element].principaldiagnosis?.chooses[i].variants) {
                    objSurvey[data[element].principaldiagnosis?.chooses[i].variants[j]] = "✓";
                    if (data[element].principaldiagnosis?.chooses[i].variants.length != utils.currentCount.resultDiagnosis || !utils.arrayCorrectVariants.includes(data[element].principaldiagnosis?.chooses[i].variants[j])) {
                        objDiagnosis["resultDiagnosis"] = false
                    }
                    else {
                        if (objDiagnosis["resultDiagnosis"] == false) continue
                        else objDiagnosis["resultDiagnosis"] = true
                    }
                }
            }
            if (i < data[element].progressionfactors?.chooses.length) {
                for (let j in data[element].progressionfactors?.chooses[i].variants) {
                    objFactors[data[element].progressionfactors?.chooses[i].variants[j]] =
                        "✓";
                    if (data[element].progressionfactors?.chooses[i].variants.length != utils.currentCount.resultProgression || !utils.arrayCorrectVariants.includes(data[element].progressionfactors?.chooses[i].variants[j])) {
                        objFactors["resultProgression"] = false
                    }
                    else {
                        if (objFactors["resultProgression"] == false) continue
                        else objFactors["resultProgression"] = true
                    }
                }
            }

            if (i < data[element].treatment?.chooses.length) {
                for (let j in data[element].treatment?.chooses[i].variants) {
                    objTreatment[data[element].treatment?.chooses[i].variants[j]] = "✓";
                    if (data[element].treatment?.chooses[i].variants.length != utils.currentCount.resultTreatment || !utils.arrayCorrectVariants.includes(data[element].treatment?.chooses[i].variants[j])) {
                        objTreatment["resultTreatment"] = false
                    }
                    else {
                        if (objTreatment["resultTreatment"] == false) continue
                        else objTreatment["resultTreatment"] = true
                    }
                }
            }
            if (i < data[element].alpha_adrenoblocker?.chooses.length) {
                for (let j in data[element].alpha_adrenoblocker?.chooses[i].variants) {
                    objAlpha[data[element].alpha_adrenoblocker?.chooses[i].variants[j]] = "✓";
                    objAlpha["resultAlpha"] = !utils.arrayCorrectVariants.includes(data[element].alpha_adrenoblocker?.chooses[i]?.variants[j]) ? false : true
                }
            }

            if (i < data[element].futuretreatment?.chooses.length) {
                for (let j in data[element].futuretreatment?.chooses[i].variants) {
                    objFutureTreatment[data[element].futuretreatment?.chooses[i].variants[j]] = "✓";
                    objFutureTreatment["resultFutureTreatment"] = !utils.arrayCorrectVariants.includes(data[element].futuretreatment?.chooses[i]?.variants[j]) ? false : true
                }
            }
            if (
                i < data[element].surveyplan?.chooses.length ||
                i < data[element].principaldiagnosis?.chooses.length ||
                i < data[element].progressionfactors?.chooses.length ||
                i < data[element].treatment?.chooses.length ||
                i < data[element].alpha_adrenoblocker?.chooses.length ||
                i < data[element].futuretreatment?.chooses.length
            ) {
                sheet.addRow({
                    sessionid: `попытка ${i + 1}`,
                    startedtime: new Date(data[element].startedtime).toLocaleDateString(),
                    stepTime1: data[element].surveyplan?.chooses[i]?.stepTime1,
                    stepTime2: data[element].principaldiagnosis?.chooses[i]?.stepTime2,
                    stepTime3: data[element].progressionfactors?.chooses[i]?.stepTime3,
                    stepTime4: data[element].treatment?.chooses[i]?.stepTime4,
                    stepTime5: data[element].alpha_adrenoblocker?.chooses[i]?.stepTime5,
                    stepTime6: data[element].futuretreatment?.chooses[i]?.stepTime6,
                    endedtime: data[element].endedtime ? new Date(data[element].endedtime).toLocaleTimeString() : null,
                    ...objSurvey,
                    ...objDiagnosis,
                    ...objFactors,
                    ...objTreatment,
                    ...objAlpha,
                    ...objFutureTreatment
                });
            }


        }
    }
    const count = sheet.rowCount
    for (let i = 3; i <= count; i++) { // отмечает за разделение сессий и раскраску правильных и не правильных ответов
        let row = sheet.getRow(i)
        if (row.values.includes('попытка 1')) row.border = { top: { style: 'double', color: { argb: 'FF00FF00' } }, }
        // console.log(sheet.getRow(i)._cells)
        for (let j in sheet.getRow(i)._cells) {
            // console.log(sheet.getRow(i)._cells[j]._value.model.value)
            if (utils.arrayCorrectVariants.includes(sheet.getRow(i)._cells[j]._column._key)) {
                const cell = sheet.getCell(sheet.getRow(i)._cells[j]._address)
                cell.border = {
                    top: { style: 'thin', color: { argb: 'black' } },
                    left: { style: 'thin', color: { argb: 'black' } },
                    bottom: { style: 'thin', color: { argb: 'black' } },
                    right: { style: 'thin', color: { argb: 'black' } }
                }
                cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF00FF00' } }
            } else if (sheet.getRow(i)._cells[j]._value.model.value == '✓') {
                const cell = sheet.getCell(sheet.getRow(i)._cells[j]._address)
                cell.border = {
                    top: { style: 'thin', color: { argb: 'black' } },
                    left: { style: 'thin', color: { argb: 'black' } },
                    bottom: { style: 'thin', color: { argb: 'black' } },
                    right: { style: 'thin', color: { argb: 'black' } }
                }
                cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFF4500' } }
            }
        }
    }

    // далее просто методами библиотеки физически создаем excel файл
    workbook.xlsx.writeBuffer().then((state) => {
        const blob = new Blob([state], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheet.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const anchor = document.createElement("a");
        anchor.href = url;
        anchor.download = `${1}.xlsx`;
        anchor.click();
        window.URL.revokeObjectURL(url);
    });
};


export const sendIntermediateResult = (variants, id, key) => { // зафиксируем номер приложения, так как в любом случае результаты будут передаваться из определенного клиентского интерфейса
    // функция для отправки промежуточных результатов, принимает неотсортированный массив, id сессии и ключ для идентификации на сервере
    const arrayForSend = []
    for (let i = 0; i < variants.length; i++) {
        if (variants[i].isChecked) {
            arrayForSend.push(variants[i].variantName)
        }
    }
    if (arrayForSend.length)
        return updateSession(arrayForSend, id, key).then(r => r)
}